import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AppHeader from "@/components/AppHeader";
import BottomNavigation from "@/components/BottomNavigation";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    
  }, [location.pathname]);

  return (
    <div className="page-container bg-gray-25">
      <AppHeader title={t('not_found.title')} />

      <main className="main-content">
        <div className="px-4 pb-4 flex items-center justify-center h-full">
          <div className="text-center space-y-3 max-w-xs mx-auto">
            <p className="text-[48px] font-bold text-brand-600 leading-none">404</p>
            <h2 className="text-[18px] font-bold text-gray-900">{t('not_found.page_not_found')}</h2>
            <p className="text-[13px] text-gray-500">{t('not_found.message')}</p>
            <a
              href="/"
              className="inline-block mt-2 px-5 py-2.5 bg-brand-600 hover:bg-brand-700 text-white text-[14px] font-semibold rounded-md transition-colors"
            >
              {t('not_found.return_home')}
            </a>
          </div>
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
};

export default NotFound;
